<template>
  <v-sheet
    :id="`${props.target}`"
    :color="
      props.color_background ? props.color_background : 'background_secondary'
    "
    :class="`
      pt-${props.pt ? props.pt : '0'} 
      pb-${props.pb ? props.pb : '0'}`">
    <v-container fluid v-if="props" class="container-padding py-6">
      <v-row
        justify="space-between"
        align="center"
        style="border: 2px solid black !important; border-radius: 10px">
        <v-col class="pa-0">
          <p
            v-if="props.text && props.text[language]"
            class="pl-2 py-4 ma-0"
            v-html="props.text[language]"></p>
        </v-col>
        <v-col class="pa-0" align="right">
          <a
            v-if="props.link_text && props.link_text[language]"
            class="pr-2 py-4 ma-0"
            v-html="props.link_text[language]"
            :href="props.link"></a>
        </v-col>
      </v-row>

      <!-- Edit dialog -->
      <v-dialog v-if="edit" persistent v-model="edit" fullscreen>
        <v-card>
          <v-card-title class="text-h5 black white--text">
            Edit Component
          </v-card-title>
          <v-card-text class="pt-5">
            <Core
              :editProps="editProps"
              @emitProps="setPreviewProps"
              @save="save"
              @cancel="cancel"
              name="Core" />
            <!-- Preview -->
            <h2 class="my-2 text-h4 black--text">Preview:</h2>
            <CompText
              v-if="previewProps"
              name="CompText"
              :props="previewProps" />
          </v-card-text>
          <v-divider></v-divider>
        </v-card>
      </v-dialog>
    </v-container>
  </v-sheet>
</template>

<script>
import { mapState } from "vuex";
import CompText from "./CompText";
import Core from "../editor/Core.vue";

export default {
  name: "CompText",
  props: ["props", "edit", "index", "componentId"],
  data() {
    return {
      editProps: {},
      previewProps: null,
    };
  },
  watch: {
    edit: function () {
      this.editProps.color_background = {};
      this.editProps.color_background.type = "color";
      this.editProps.color_background.name = "color_background";
      this.editProps.color_background.value =
        this.props.color_background ?? "#FFFFFF";

      this.editProps.target = this.props.target ?? "";
      this.editProps.pt = this.props.pt ?? 0;
      this.editProps.pb = this.props.pb ?? 0;

      this.editProps.text = {};
      this.editProps.text.type = "text";
      this.editProps.text.name = "text";
      this.editProps.text.value = this.props.text ?? {};

      this.editProps.link_text = {};
      this.editProps.link_text.type = "text";
      this.editProps.link_text.name = "link_text";
      this.editProps.link_text.value = this.props.link_text ?? {};

      this.editProps.link = {};
      this.editProps.link.type = "link";
      this.editProps.link.name = "link";
      this.editProps.link.value = this.props.link ?? "";
    },
  },
  computed: {
    ...mapState({
      language: state => {
        return state.language ?? "de";
      },
    }),
  },
  methods: {
    save(previewProps) {
      this.previewProps = JSON.parse(JSON.stringify(previewProps));
      this.$emit("save", this.previewProps, this.index, this.componentId);
    },
    cancel() {
      this.$emit("cancel");
    },
    setPreviewProps(previewProps) {
      this.previewProps = JSON.parse(JSON.stringify(previewProps));
    },
  },
  components: {
    Core,
    CompText,
  },
};
</script>

<style></style>
